import React, {useEffect, useState, useMemo} from "react";
import * as S from "./MuliticityPopup.styles";
import { useSelector, useDispatch, useStore } from "react-redux";
import AutoSuggest from "../../../../components/autosuggest/autosuggest";
import { destinationSelector, multicityStopOversSelector, tripTypeSelector, sourceSelector } from "../../../../common/redux/selector";
import { UPDATE_MULTICITY_STOPOVERS, UPDATE_PREVIOUS_MULTICITY_STOPOVERS } from "../../redux/action-types";
import { popularSearchSelector } from "../../../Homepage/redux/selector";
import { gcTripCategoryScreen, pushCtaOmniEvents } from "../../../../../shared/config/omni";
import { HOME_STOP_ERROR_TXT, SEO } from "../../../../../shared/config/constants";
import { ADD_STOP, CABS_LISTING_ROUTE, CLICKED, LISTINGPAGE, MOB_CABS_LISTING, REMOVE_STOP, STOP_BACK_CLICKED, STOP_DONE_CLICKED, STOP_EMPTY_ERROR } from "../../../../../shared/utils/util-constants";
import { CTA_TYPE } from "../../../../../shared/utils/omni-utils";

const Auto = ({ autosuggestRef, props, inputRef, label, setInitialPage, onShowInitialPage, handleKeyBoard, id, autoFocus }) => {
  const dispatch = useDispatch();
  const store = useStore();

  return (
    <S.WidgetType
      ref={autosuggestRef}
    >
      <S.TripTypeTxt>{label}</S.TripTypeTxt>
      <S.OutStandingWarpper>
        <S.OutStandingInputInner
          {...props}
          autoFocus={onShowInitialPage || autoFocus}
          onKeyDown={handleKeyBoard}
          onClick={() => {
            setInitialPage(true)
            if (label?.toLowerCase()?.includes('stop')) {
              setTimeout(() => {
                const stopOvers = store.getState()?.common?.stopOvers ? store.getState()?.common?.stopOvers : []
                const newStopOvers = JSON.parse(JSON.stringify(stopOvers))
                const index = newStopOvers.findIndex((item) => item?.id === id)
                if (index > -1 && newStopOvers[index]?.value?.name) {
                  newStopOvers[index].value = {}
                }
                dispatch({
                  type: UPDATE_PREVIOUS_MULTICITY_STOPOVERS,
                  previousStopOvers: stopOvers
                })
                dispatch({
                  type: UPDATE_MULTICITY_STOPOVERS,
                  stopOvers: newStopOvers
                })
              }, 1)
            }
          }}
          ref={inputRef}
        ></S.OutStandingInputInner>
      </S.OutStandingWarpper>
    </S.WidgetType>
  );
};

const MuliticityPopup = ({onClosePopup, isSeo}) => {
  const dispatch = useDispatch();
  const stopOvers = useSelector(multicityStopOversSelector)
  const triptype = useSelector(tripTypeSelector);
  const popularSearch = useSelector(popularSearchSelector);
  const source = useSelector(sourceSelector);
  const destination = useSelector(destinationSelector);
  const [autoSuggestFieldError, setAutoSuggestFieldError] = useState(false)
  const [autofocusIndex, setAutoFocusIndex] = useState(-1)

  useEffect(() => {
    if (stopOvers?.length) {
      const index = stopOvers.findIndex(stop => !stop?.value?.name)
      if (index > -1) {
        setAutoFocusIndex(index)
      }
    } else {
      setAutoFocusIndex(-1)
    }
  }, [stopOvers])

  const onAddStopsClick = () => {
    const newStopOvers = JSON.parse(JSON.stringify(stopOvers))
    const newStop = {
      id : newStopOvers.length + 1,
      value: {}
    }
    newStopOvers.push(newStop)
    pushCtaOmniEvents(isSeo ? `${MOB_CABS_LISTING}_${SEO}_${ADD_STOP}_${newStopOvers.length + 1}_${CLICKED}` : `${MOB_CABS_LISTING}_${ADD_STOP}_${newStopOvers.length + 1}_${CLICKED}`, CTA_TYPE.BUTTON, LISTINGPAGE, CABS_LISTING_ROUTE)
    dispatch({
      type: UPDATE_MULTICITY_STOPOVERS,
      stopOvers: newStopOvers
    })
  }

  const onStopClearClick = (id) => {
    const newStopOvers = JSON.parse(JSON.stringify(stopOvers))
    if (newStopOvers.length === 1) {
      newStopOvers.splice(0, 1)
    } else if (id === newStopOvers.length) {
      newStopOvers.pop()
    } else {
      newStopOvers.splice(id, 1)

      for (let i = id; i < newStopOvers.length; i++) {
        newStopOvers[i].id = i + 1;
      }
    }

    pushCtaOmniEvents(isSeo ? `${MOB_CABS_LISTING}_${SEO}_${REMOVE_STOP}_${id + 1}_${CLICKED}` : `${MOB_CABS_LISTING}_${REMOVE_STOP}_${id + 1}_${CLICKED}`, CTA_TYPE.BUTTON, LISTINGPAGE, CABS_LISTING_ROUTE)

    dispatch({
      type: UPDATE_MULTICITY_STOPOVERS,
      stopOvers: newStopOvers
    })

    dispatch({
      type: UPDATE_PREVIOUS_MULTICITY_STOPOVERS,
      stopOvers: newStopOvers
    })

    if (!newStopOvers?.length) {
      onClosePopup()
    }
  }

  const onBackClick = (e, isDone = false) => {
    if (e.target === e.currentTarget) {
      const newStopOvers = JSON.parse(JSON.stringify(stopOvers))

      const emptyStops = newStopOvers.find(stop => !stop?.value?.name)

      if (emptyStops) {
        const tripTypeVal = 'outstation'
        pushCtaOmniEvents(`${MOB_CABS_LISTING}_${tripTypeVal}_${STOP_EMPTY_ERROR}`, CTA_TYPE.BUTTON, LISTINGPAGE, CABS_LISTING_ROUTE)
        setAutoSuggestFieldError(true)
        return
      }

      setAutoSuggestFieldError(false)
      const actionName = isSeo ? (isDone ? `${MOB_CABS_LISTING}_${SEO}_${STOP_DONE_CLICKED}` : `${MOB_CABS_LISTING}_${SEO}_${STOP_BACK_CLICKED}`) : (isDone ? `${MOB_CABS_LISTING}_${STOP_DONE_CLICKED}` : `${MOB_CABS_LISTING}_${STOP_BACK_CLICKED}`)

      pushCtaOmniEvents(actionName, CTA_TYPE.BUTTON, LISTINGPAGE, CABS_LISTING_ROUTE)
  
      dispatch({
        type: UPDATE_MULTICITY_STOPOVERS,
        stopOvers: newStopOvers
      })
  
      onClosePopup()
    }
  }

  const popuptHeight = useMemo(() => {
    switch (stopOvers?.length) {

      case 1 : 
        return '56%'
        
      case 2 :
        return '56%'

      case 3 :
        return '56%'

      case 4 :
        return autoSuggestFieldError ? '64%' : '60%'

      case 5 :
        return autoSuggestFieldError ? '68%' : '64%'

      default :
        return "56%"
    }
  }, [stopOvers, autoSuggestFieldError]);

  return (
    <S.PopupBackground onClick={(event) => onBackClick(event)}>
      <S.Popup isError={autoSuggestFieldError} height={popuptHeight}>
        {stopOvers?.length && triptype?.rf !== "at" && triptype?.rf !== "hr" ? (
          <>
            {stopOvers.map((details, index) => {
              return (
                <S.StopOversCont tabIndex={index} key={index}>
                  <div style={{width: "100%"}}>
                    <AutoSuggest 
                      widget={Auto} 
                      width="100%" 
                      label={`Stop ${details?.id}`} 
                      labelVal={`Stop ${details?.id}`} 
                      title={details?.value?.name || ""} 
                      type={triptype?.rf} 
                      popularSearch={popularSearch} 
                      autoFocus={autofocusIndex === index} 
                      invokedFor={gcTripCategoryScreen} 
                      placeVal={`Enter stop ${details?.id}`} 
                      id={details?.id}
                    />
                    {autoSuggestFieldError && !details?.value?.name ? (
                    <S.ErrorContainer margin={"-0.5rem 0"}>
                      {HOME_STOP_ERROR_TXT}
                    </S.ErrorContainer>
                  ) : null}
                  </div>
                  <S.CloseCont onClick={() => onStopClearClick(index)}>
                    <span className="close"></span>
                  </S.CloseCont>
                </S.StopOversCont>
              )})}
          </>
        ) : null}
        <>
          {stopOvers?.length < 5 && triptype?.rf !== "at" && triptype?.rf !== "hr" ? (
            <S.StopoversTextCont onClick={onAddStopsClick}>
              + Add Stops
              <span>
                New
              </span>
            </S.StopoversTextCont>
          ) : null}
        </>
        <S.ButtonWrap>
          <button onClick={(e) => onBackClick(e, true)}>
            Done
          </button>
        </S.ButtonWrap>
      </S.Popup>
    </S.PopupBackground>
  );
};

export default React.memo(MuliticityPopup);
